<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @exps="exps"  @search="search" @reflash="reflash" ref="SetBtn"></buttonlist>
		<!-- <el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" size="mini"  @click="send">获取数据</el-button>
				</div>
			</div>
		</el-card> -->
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px">
				<div>
					<el-button type="primary" size="mini" @click="monthCheck(0)">{{$t('getapi[1273]')}}</el-button>
				</div>
				<wTable
						id="xpane-0"
						:data="dataSet"
						:loading="loading"
						queryData="SalDetailInfoEx"
						:filter_language="['virtual_flag','invoice_status','co_line_status']"
						:filter_thousandth="['sale_qty','inv_qty','sal_base_net_unit','sal_base_net_amount','invoice_qty','invoice_base_net_unit','invoice_base_net_amount','invoice_local_net_unit','invoice_local_net_amount',
						'issue_material_unit','issue_man_unit','issue_charge_unit','issue_material_amount','issue_man_amount','issue_charge_amount','multiple_board_cost','multiple_chemical_cost',
						'multiple_other_cost','bom_cost','sum_outsource','bom_sumcost','Cust_Material_cost','Cust_Man_cost','Cust_Charge_cost','Item_Material_cost','Item_Man_cost','Item_Charge_cost',
						'Ship_Charge_cost','Year_Cust_Material_cost','Year_Cust_Man_cost','Year_Cust_Charge_cost','Year_Item_Material_cost','Year_Item_Man_cost','Year_Item_Charge_cost','Year_Ship_Charge_cost']"
						:filter_date="['finance_date','invoice_create_date','invoice_audit_date']"
						:header="tableHeader"
						:option="tableOption"
						ref="singleTable"
						:checkflg="false"
				></wTable>
				<!--<el-table
					:data="dataSet"
					v-loading="loading"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight - reduceTableHeight"
					header-row-class-name="headerclass"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
				>

				<el-table-column show-overflow-tooltip prop="invoice_audit_year" :label="$t('getapi[7733]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_audit_month" :label="$t('getapi[7734]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="order_audit_year" :label="$t('getapi[7735]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="order_audit_month" :label="$t('getapi[7736]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="virtual_flag" :label="$t('getapi[7737]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_name"  width="120px"  :label="$t('getapi[116]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="digest" :label="$t('getapi[7340]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[463]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[6489]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="verify_status" :label="$t('getapi[2852]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="hook_flag" :label="$t('getapi[7738]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="sale_measure_unit" :label="$t('getapi[2658]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="category_first_name" :label="$t('getapi[169]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="category_second_name" :label="$t('getapi[170]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="category_third_name" :label="$t('getapi[171]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="sale_qty" width="120px" :label="$t('getapi[7739]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="inv_measure_unit" width="120px"  :label="$t('getapi[1340]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="inv_qty" width="120px"  :label="$t('getapi[7740]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="sal_base_net_unit" width="140px"  :label="$t('getapi[7741]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="sal_base_net_amount" width="140px"  :label="$t('getapi[3736]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_no" :label="$t('getapi[2992]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_status" :label="$t('getapi[3694]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_code" :label="$t('getapi[3681]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_create_date" width="120px"  :label="$t('getapi[7742]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_audit_date" :label="$t('getapi[3892]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_qty" :label="$t('getapi[7743]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_base_net_unit" :label="$t('getapi[7744]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_base_net_amount" :label="$t('getapi[5124]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="currency_exchange_rate" :label="$t('getapi[7745]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_local_net_unit" width="120px"  :label="$t('getapi[7746]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="invoice_local_net_amount" width="120px"  :label="$t('getapi[7747]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="payment_date" :label="$t('getapi[3686]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="sale_man" :label="$t('getapi[7748]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="customer_code" :label="$t('getapi[2610]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="customer_name" :label="$t('getapi[2584]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="customer_contact_person" :label="$t('getapi[7749]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="issue_material_unit" width="120px"  :label="$t('getapi[7750]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="issue_man_unit" width="120px"  :label="$t('getapi[7751]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="issue_charge_unit" width="120px"  :label="$t('getapi[7752]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="issue_material_amount" width="120px"  :label="$t('getapi[7585]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="issue_man_amount" width="120px"  :label="$t('getapi[7586]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="issue_charge_amount" width="120px"  :label="$t('getapi[7587]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="co_code"  width="120px"  :label="$t('getapi[2291]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="currency_code" :label="$t('getapi[3108]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="innerforeign_flag" :label="$t('getapi[7753]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="co_line_no" :label="$t('getapi[2840]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="co_line_status" :label="$t('getapi[7754]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="multiple_board_cost" :label="$t('getapi[7703]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="multiple_chemical_cost" :label="$t('getapi[7704]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="multiple_other_cost" :label="$t('getapi[224]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="bom_cost" :label="$t('getapi[7755]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="sum_outsource" :label="$t('getapi[7563]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="bom_sumcost" :label="$t('getapi[7552]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[7756]')" align="left"></el-table-column>
				<el-table-column show-overflow-tooltip prop="proforma_invoice_no" label="Invoice No" align="left"></el-table-column>
				</el-table>-->
				<!--show-overflow  省略号 <vxe-table
					:data="dataSet"
					v-loading="loading"
					border
					stripe
					resizable
					size="mini"
					:height="tableHeight"
				>

				<vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')" width='100'/>
				<vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[149]')" width='100'/>
				<vxe-table-column show-overflow-tooltip field="part_master_unit" title="计量单位" width='100'/>
				<vxe-table-column show-overflow field="part_name" title="物料名称" width='150' />

				<vxe-table-column show-overflow-tooltip field="vender_count" title="报价供应商数量" width='150' align="right"/>
				<vxe-table-column show-overflow-tooltip field="sum_net_unit" title="合计不含税单价" width='150' align="right"/>
				<vxe-table-column show-overflow-tooltip field="sum_unit" title="合计含税单价" width='150' align="right"/>
				<vxe-table-column show-overflow-tooltip field="avg_net_unit" title="平均不含税单价" width='150' align="right"/>
				<vxe-table-column show-overflow-tooltip field="avg_unit" title="平均含税单价" width='150' align="right"/> -->
				<!-- </vxe-table> -->
			</li>
		</ul>
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="SalDetailInfoEx" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[6624]')" queryData="SalDetailInfoEx" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
		<!-- 改变表格顺序 -->
		<!-- <ctable :isVisible="false" title="CSV" queryData="SalLogicticscsvViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable> -->
	
		<!-- 详情页面 -->
		<!-- <purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage> -->
		<!-- 选择时间 -->
		<el-dialog v-dialogDrag :title="$t('getapi[6433]')" :visible.sync="dialogVisible" width="30%">
			<div class="bbl">
			<span>{{$t('getapi[6434]')}}</span>
			<el-date-picker v-model="copyparam.startMonth" popper-class="select-option" type="month" value-format="yyyy-MM" size="mini"></el-date-picker>
			</div>
			<div class="bbl">
			<span>{{$t('getapi[6435]')}}</span>
			<el-date-picker v-model="copyparam.copyMonth" popper-class="select-option" type="month" value-format="yyyy-MM" size="mini"></el-date-picker>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="copyconfirm">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :title="$t('getapi[1273]')" :visible.sync="monthCheckVisible" width="30%" :close-on-click-modal="false">
			<table>
				<tr>
					<td style="width:60px">{{ $t("getapi[1974]") }}</td>
					<td style="width:150px;">
						<!--<el-select
								filterable
								v-model="year"
								size="mini"
								style="margin-righ:20px"
						>
							<el-option
									v-for="item in yearList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>-->
						<el-input v-model="year" type="text" size="mini"></el-input>
					</td>
					<td style="width:60px">{{ $t("getapi[1975]") }}</td>
					<td style="width:150px;">
						<el-select
								filterable
								v-model="month"
								size="mini"
								style="margin-righ:20px"
								@change="getMonthData()"
						>
							<el-option
									v-for="item in monthList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</td>
				</tr>
			</table>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="monthCheckVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="confirmMonthCheck(0)">{{$t('getapi[2051]')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import {Loading} from 'element-ui';
export default {
	name:'3_saledetail',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('3_saledetail'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            reduceTableHeight: Common.reduceTableHeight3,
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				send: false,
				print:false,
				//删除
				delete: false,
			},
            monthList: [
                {
                    value: 1,
                    label: 1,
                },
                {
                    value: 2,
                    label: 2,
                },
                {
                    value: 3,
                    label: 3,
                },
                {
                    value: 4,
                    label: 4,
                },
                {
                    value: 5,
                    label: 5,
                },
                {
                    value: 6,
                    label: 6,
                },
                {
                    value: 7,
                    label: 7,
                },
                {
                    value: 8,
                    label: 8,
                },
                {
                    value: 9,
                    label: 9,
                },
                {
                    value: 10,
                    label: 10,
                },
                {
                    value: 11,
                    label: 11,
                },
                {
                    value: 12,
                    label: 12,
                },
            ],
            yearList: [],
            month:'',
            yearL:'',
            monthCheckVisible: false,//月结弹窗
            scrollTop:0,
            year:''
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
        let thisyear = new Date().getFullYear();
        for (let i = 0; i < 5; i++) {
            let obj = {
                value: thisyear - i,
                label: thisyear - i,
            };
            that.yearList.push(obj);
        }
        that.year = thisyear;
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SalDetailInfoEx',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6624]"),this.$t("getapi[8045]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			let limits=1;
			//that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);

			//that.$refs.SetBtn.SetButtonEnable('export',true);
			that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			return;

			// //只读权
			// if (that.$limits.ReadOnlyRightsView('plv2', 375, 1, that.total)) {
			// 	if (that.total > 0) {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 	} else {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 	}
			// }
			// //操作权限-查询级别
			// limits = that.$limits.OperationAuthorityView('plv2', 375, 1, that.total);
			// // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			// switch (limits) {
			// 	case -1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	default:
			// 		break;
			// }
			// if(limits==-1||limits==1)that.closeAllRightButton();
            // else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
			
		},
		closeAllRightButton(){
			let that =this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		if(that.selectIDList.length>0){
			that.btn.send = true;
			that.btn.delete = true;
			that.btn.print = true;
		}else{
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		}
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('3_saledetail',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'SalDetailInfoEx');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost('/CostCalc/SaleView/GetSalDetailViewEx', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		copyconfirm(){
			//  
			let that = this;
			that.btn.copy = false
			let parm = {
			"newmonth": that.copyparam.copyMonth.split("-")[1],
			"newyear": that.copyparam.copyMonth.split("-")[0],
			"oldmonth": that.copyparam.startMonth.split("-")[1],
			"oldyear": that.copyparam.startMonth.split("-")[0],
			}

			that.$http.urlpost('/Inv/PartCost/InvPartStdCostCopyCost', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.btn.copy = true;
				that.dialogVisible = false;
			});


		},
		send(){
			let that = this;
			that.loading = true;
			that.$http.urlpost('/CostCalc/PurView/GetLatestPurPriceView', {}, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
				}
				that.loading = false;
			});
		},
		print(){
			let that = this;
			let parm = {
			po_no: '',
			TemplateName: '08Invoice_CSV.xlsx'
			};

			for(let i=0;i<that.selectIDList.length;i++){
			parm.po_no= parm.po_no + "'"+that.selectIDList[i].exclusively_id+"',";
			}
			parm.po_no =  parm.po_no.substring(0, parm.po_no.length - 1);

			that.btn.print = false;
			that.loading = true;
			that.$http.urlpost('/Print/CSVPrint', parm, function (res) {
			that.btn.print = true;
			if (res.Success == 1) {
			let hrefurl = res.Key;
			window.open(hrefurl);
			} 
			that.loading = false;
			});
		},
		deleteline(){
			let that = this;
			let parm = {
				Delivery_Note_N: that.selectIDList[0].Delivery_Note_N,
			};
			that.$http.urlpost('/Sal/Tru/DeleteCsv', parm, function(res) {
				if (res.Success == 1) {
					that.reflash();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
				}
			});

		},
		// 导出
		exps() {
			/*let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost('/CostCalc/SaleView/GetSalDetailViewExToExecl', data, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "SalDetailInfoEx",
                fromname: that.$t('getapi[6624]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {},
        monthCheck(val) {
            let that = this
			that.monthCheckVisible = true
        },
		confirmMonthCheck(val){
            let that = this
            if (that.month == '' || that.year == '') {
                that.$message.warning(that.$t('getapi[8783]'))//'年月不能为空'
                return
            }
            let parm = {
                TYear: that.year,
                Month: that.month,
                Confirmflag: val
            }
            let loadingInstance = Loading.service(Common.maskoption);
            that.$http.urlpost('/Sal/Tru/SalDetailViewExMonthCheck', parm, function (res) {
                if (res.Success == 1) {
                    that.monthCheckVisible = false
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                } else if (res.Success == 2) {
                    that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.confirmMonthCheck(res.Success)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                }
                loadingInstance.close()
            });
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
